import React from "react";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import ShowImageForAdmin from "../../../components/showImageForAdmin";

const ShowCreatedProductDetails = ({
  createdProductDetail,
  setCreatedProductDetail,
}) => {
  return (
    <>
      {createdProductDetail.length > 0 &&
        createdProductDetail.map((product, index) => (
          <div key={index} className="border p-3 mb-4">
            {/* <h4>Capacity: {product.capacity} GB</h4> */}
            <div className="d-flex justify-content-between align-items-center">
              <h4>Capacity: {product.capacity} GB</h4>

              {/* Delete Capacity Button */}
              <Button
                variant="danger"
                className="btn-sm"
                onClick={() => {
                  setCreatedProductDetail((prevState) =>
                    prevState.filter((_, i) => i !== index)
                  );
                }}
              >
                <i className="fas fa-trash" />
              </Button>
            </div>

            {product.details.length > 0 &&
              product.details.map((detail, i) => (
                <div key={i} className="border p-3 mb-3">
                  <h5>Saved Product {i + 1}</h5>

                  <InputGroup className="my-2">
                    <InputGroup.Text>Details</InputGroup.Text>

                    {/* Color */}
                    <FormControl value={detail.color} readOnly />

                    {/* Price */}
                    <FormControl value={`Price: $${detail.price}`} readOnly />

                    {/* Discount */}
                    <FormControl
                      value={`Discount: $${detail.discount}`}
                      readOnly
                    />

                    {/* Quantity */}
                    <FormControl value={`${detail.quantity} items`} readOnly />
                  </InputGroup>

                  {/* Show Images */}
                  <div
                    style={{
                      paddingLeft: "1rem",
                      paddingRight: "1rem",
                    }}
                  >
                    {detail.images?.length > 0 && (
                      <ShowImageForAdmin source={detail.images} />
                    )}
                  </div>
                </div>
              ))}
          </div>
        ))}
    </>
  );
};

export default ShowCreatedProductDetails;
